import { Component, input, viewChild } from '@angular/core';
import { TooltipComponent } from '../tooltip/tooltip';

@Component({
  selector: 'ui-simple-tooltip',
  imports: [TooltipComponent],
  templateUrl: './simple-tooltip.html',
})
export class SimpleTooltip {
  id = input.required<string>();
  anchorName = input<`--${string}` | null>(null);
  text = input.required<string>();

  private element = viewChild.required(TooltipComponent);

  show() {
    this.element().show();
  }

  hide() {
    this.element().hide();
  }
}
